import { render } from "./splitPanel.vue?vue&type=template&id=7c69dde0&scoped=true"
import script from "./splitPanel.vue?vue&type=script&lang=js"
export * from "./splitPanel.vue?vue&type=script&lang=js"

import "./splitPanel.vue?vue&type=style&index=0&id=7c69dde0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c69dde0"]])

export default __exports__